import Vue from 'vue'
import { datadogRum } from '@datadog/browser-rum'
import VueApexCharts from 'vue-apexcharts'
import './plugins/axios'
import store from '@/store/index'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/shepherd'
import './core'
import Datadog from './plugins/datadog'
import acl from './plugins/acl'

Vue.config.productionTip = false
Vue.use(Datadog, datadogRum)
Vue.use(acl, { store })
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App, { ref: 'app' }),
}).$mount('#app')
